module.exports = __webpack_public_path__ + "img/Menuchat.f6bd008e.svg";